<template>
  <div>
    <div>
      <p class="sheet-title">{{ productDescriptionTitle }}</p>
      <content-show-more v-model="shouldAllShow" class-name="ma-0">
        <div id="productIntro__sheetContent" :class="[{ allContent: shouldAllShow }, 'sheet-content']">
          <product-content-list :nodes="introList" />
        </div>
      </content-show-more>
    </div>
  </div>
</template>

<script>
import ContentShowMore from '@/components/ContentShowMore.vue'
import ProductContentList from '@/components/page/products/ProductContentList.vue'

export default defineComponent({
  name: 'ProductIntro',
  components: {
    ContentShowMore,
    ProductContentList,
  },
  props: {
    introList: { type: Array, default: () => [] },
  },
  setup() {
    const { productDescriptionTitle } = usePlatformProductContext()

    return {
      productDescriptionTitle,
    }
  },
  data() {
    return {
      shouldAllShow: false,
    }
  },
})
</script>

<style lang="scss" scoped>
.sheet-content {
  position: relative;
  max-height: 400px;
  overflow: hidden;
  &#productIntro__sheetContent {
    margin-bottom: 0px;
    :deep(p) {
      margin-bottom: 0px;
    }
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 70%);
  }

  &.allContent {
    max-height: none;
    &#productIntro__sheetContent {
      margin-bottom: 20px;
    }
    &::after {
      content: none;
    }
  }

  @include xxs {
    max-height: 340px;
    &#productIntro__sheetContent {
      margin-bottom: 0px;
    }
    &.allContent {
      &#productIntro__sheetContent {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
